import {Component} from '@angular/core';
import {TranslateService, TranslatePipe, TranslateLoader, TranslateStaticLoader} from 'ng2-translate/ng2-translate';


@Component({
  templateUrl: 'build/pages/settings/settings.html',
    pipes: [TranslatePipe]
})
export class SettingsPage {
  idioma: string;
  
  constructor(public translate: TranslateService) {
    this.idioma = translate.currentLang;
  }

  onChange(lang) {
    this.translate.use(lang);
  }
}
